import { useAtom } from "@dbeining/react-atom";
import { faBuilding, faGlobe, faSitemap, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { userAtom } from "../../atoms";
import { IRole } from "../../customTypings/user/Role";
import { Role } from "../../utils";

const SettingsPage = () => {
    const currentUser = useAtom(userAtom);
    const isAdmin = currentUser?.identity.roles.some((role: IRole) => [Role.Admin, Role.SystemAdmin].indexOf(role.name) >= 0);
    return (
        <Container fluid>
            <Helmet>
                <title>Settings</title>
            </Helmet>

            <h1>Settings</h1>

            {isAdmin && (
                <>
                    <Row className="mb-3">
                        <h3>Administration</h3>
                    </Row>
                    <Row className="g-3 mb-4">
                        <Col xs={12} sm={6} md={4}>
                            <Link className="text-decoration-none" to="/users">
                                <Card className="bg-light shadow h-100">
                                    <Card.Body>
                                        <FontAwesomeIcon icon={faUsers} size="2x" className="mb-2" />
                                        <Card.Title>Users</Card.Title>
                                        <Card.Text className="text-muted small">Manage users and roles</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <Link className="text-decoration-none" to="/company">
                                <Card className="bg-light shadow h-100">
                                    <Card.Body>
                                        <FontAwesomeIcon icon={faBuilding} size="2x" className="mb-2" />
                                        <Card.Title>Company</Card.Title>
                                        <Card.Text className="text-muted small">Company profile and details</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <Link className="text-decoration-none" to="/websitesettings">
                                <Card className="bg-light shadow h-100">
                                    <Card.Body>
                                        <FontAwesomeIcon icon={faGlobe} size="2x" className="mb-2" />
                                        <Card.Title>Website settings</Card.Title>
                                        <Card.Text className="text-muted small">Site configuration</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <Link className="text-decoration-none" to="/organisations">
                                <Card className="bg-light shadow h-100">
                                    <Card.Body>
                                        <FontAwesomeIcon icon={faSitemap} size="2x" className="mb-2" />
                                        <Card.Title>Organisations</Card.Title>
                                        <Card.Text className="text-muted small">Organisation structure</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    </Row>
                </>
            )}
        </Container>
    );
};

export { SettingsPage };
